<div class="container">
    <h2>Select a task to execute on selected devices.</h2>
    <div style="overflow-y: scroll;">
        <tools-table [Headers]="tasksHeaders" [ApiPath]="'/teltonika/tasks/'" #table [Search]="true" [SortColumn]="''"
            [Slim]="true" [Selectable]="true" [Multiple]="false" [DynamicCount]="false"
            (Selected)="taskSelected($event)">
        </tools-table>
    </div>
    <div class="buttons">
        <button mat-raised-button [disabled]="selectedTask==null || selectedTask.length<=0"
            (click)="closeDialog(true)"><mat-icon>terminal</mat-icon>Execute</button>
        <button mat-raised-button (click)="closeDialog(false)"><mat-icon>close</mat-icon>Close</button>
    </div>
</div>